function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { CssContainer } from "../../components/container";
import { Card, Empty, PlunkDropDown } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import { hasTenantFeature } from "../../functions/tenant-features";
import { money, ShowAll } from "../sales/territory-redesign-kit";
import { Menu } from "../products/px-common";
import { RepSubTop } from "../sales/rep-common";
import { MONTHS, goalMoney, parseAmount, spread, Bars } from "../sales/targets-kit";
import { fetchStore, putStore, isAdminUser, storeName, typeLabel } from "./common";

/*
 * Store goals (Stores redesign 2026-10-09, PlunkDocs mockups/stores-redesign-2026-10-09.html, board "3 · Store targets").
 * Same layout as Sales targets (views/sales/targets.jsx, shared pieces in views/sales/targets-kit.jsx, styles stg-*):
 * one yearly goal per store, spread across the months the way that store's sales fell last year; "By month" opens
 * the 12 month inputs. The save payload is unchanged (monthly cells), so the backend is too.
 *
 *   GET /v1/store/targets?from=&to=           the grid (stores × months) + lastYear/prevMonths/soldSoFar (1.0.174)
 *   GET /v1/store/targets/seed?from=&to=&growth=   empty cells filled from last year's same month × (1 + growth)
 *   PUT /v1/store/targets [{ storeId, period, revenueGoal }]
 *
 * Owner and administrator only.
 */
const CAP = 15;
class StoreTargetsView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "setYear", year => {
      this.setState({
        year: Number(year)
      }, () => this.load(Number(year)));
    });
    // ---- actions ----
    _defineProperty(this, "fill", () => {
      const {
        year,
        growth
      } = this.state;
      this.setState({
        busy: true
      });
      fetchStore(`/store/targets/seed?from=${year}-01&to=${year}-12&growth=${Number(growth) || 0}`).then(g => {
        if (!this._alive) return;
        // Filled-in cells arrive suggested=true; saved cells come back as they are. Suggested cells join the
        // unsaved set (so Save writes them) and stay yellow until edited or saved.
        const dirty = {
          ...this.state.dirty
        };
        const sugg = {
          ...this.state.sugg
        };
        (g && g.rows || []).forEach(row => {
          Object.entries(row.cells || {}).forEach(([period, c]) => {
            if (c && c.suggested && c.revenueGoal != null) {
              const k = this.key(row.storeId, period);
              dirty[k] = String(Math.round(Number(c.revenueGoal)));
              sugg[k] = true;
            }
          });
        });
        // Keep last year's figures from the first read when the fill response predates them.
        const prevRows = new Map((this.state.grid && this.state.grid.rows || []).map(r => [String(r.storeId), r]));
        const rows = (g && g.rows || []).map(r => {
          const o = prevRows.get(String(r.storeId)) || {};
          return {
            ...r,
            lastYear: r.lastYear != null ? r.lastYear : o.lastYear,
            prevMonths: r.prevMonths || o.prevMonths,
            soldSoFar: r.soldSoFar != null ? r.soldSoFar : o.soldSoFar
          };
        });
        this.setState({
          grid: {
            ...(g || {}),
            rows
          },
          dirty,
          sugg,
          drafts: {},
          busy: false,
          note: `Goals filled in from ${year - 1} sales plus ${Number(growth) || 0}%. Yellow goals are not saved yet. Change any you like, then Save goals.`
        });
      }).catch(() => this._alive && this.setState({
        busy: false,
        note: "Could not fill in goals. Try again."
      }));
    });
    _defineProperty(this, "save", () => {
      const targets = this.pendingTargets();
      if (!targets.length) return;
      this.setState({
        busy: true
      });
      putStore("/store/targets", targets).then(r => {
        if (!this._alive) return;
        this.setState({
          busy: false,
          note: `Saved. ${((r && r.saved) != null ? r.saved : targets.length).toLocaleString("en-US")} monthly goals updated.`
        });
        this.load(undefined, true);
      }).catch(() => this._alive && this.setState({
        busy: false,
        note: "Save failed. Try again."
      }));
    });
    _defineProperty(this, "applyCsv", () => {
      // storeId,period,revenue_goal (or scope,storeId,period,revenue_goal). Header row skipped.
      const {
        grid,
        csvText
      } = this.state;
      const known = new Set((grid && grid.rows || []).map(r => String(r.storeId)));
      const byName = new Map((grid && grid.rows || []).map(r => [storeName(r).toLowerCase(), String(r.storeId)]));
      const dirty = {
        ...this.state.dirty
      };
      const sugg = {
        ...this.state.sugg
      };
      let applied = 0;
      let skipped = 0;
      csvText.split(/\r?\n/).forEach(line => {
        const parts = line.split(",").map(p => p.trim().replace(/^"|"$/g, ""));
        if (parts.length < 3) return;
        let [a, b, c, d] = parts;
        let id, period, goal;
        if (/^\d{4}-\d{2}$/.test(b)) {
          id = a;
          period = b;
          goal = c;
        } else {
          id = b;
          period = c;
          goal = d;
        }
        if (!/^\d{4}-\d{2}$/.test(period || "") || !Number.isFinite(Number(goal))) {
          if (id && !/store|period/i.test(line)) skipped++;
          return;
        }
        if (!known.has(id)) id = byName.get(String(id).toLowerCase()) || id;
        if (!known.has(id)) {
          skipped++;
          return;
        }
        const k = this.key(id, period);
        dirty[k] = String(Number(goal));
        delete sugg[k];
        applied++;
      });
      this.setState({
        dirty,
        sugg,
        drafts: {},
        csvOpen: false,
        csvText: "",
        note: `${applied} monthly goals filled in from the spreadsheet${skipped ? `. ${skipped} rows skipped (store not on the list or month not YYYY-MM)` : ""}. Check them, then Save goals.`
      });
    });
    // Template: one row per store × month with the current goal, so ids and months are right.
    _defineProperty(this, "downloadTemplate", () => {
      const {
        grid,
        year
      } = this.state;
      const rows = grid && grid.rows || [];
      let csv = "storeId,period,revenue_goal,store_name\n";
      rows.forEach(r => this.periodsOf().forEach(p => {
        csv += `${r.storeId},${p},${Number(this.valueOf(r, p)) || 0},"${storeName(r).replace(/"/g, '""')}"\n`;
      }));
      const blob = new Blob([csv], {
        type: "text/csv;charset=utf-8"
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `store-goals-${year}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    });
    _defineProperty(this, "onFile", e => {
      const file = e.target.files && e.target.files[0];
      e.target.value = "";
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => this.setState({
        csvText: String(reader.result || "")
      }, this.applyCsv);
      reader.readAsText(file);
    });
    const y = new Date().getFullYear();
    this.state = {
      year: y,
      grid: undefined,
      error: false,
      growth: 8,
      dirty: {},
      sugg: {},
      drafts: {},
      open: {},
      q: "",
      showAll: false,
      busy: false,
      csvOpen: false,
      csvText: "",
      note: null
    };
    this._alive = true;
  }
  componentDidMount() {
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  load(year = this.state.year, keepNote) {
    this.setState(s => ({
      grid: undefined,
      dirty: {},
      sugg: {},
      drafts: {},
      open: {},
      error: false,
      note: keepNote ? s.note : null
    }));
    fetchStore(`/store/targets?from=${year}-01&to=${year}-12`).then(g => this._alive && this.setState({
      grid: g || {}
    })).catch(() => this._alive && this.setState({
      grid: null
    }));
  }
  // ---- cells ----
  periodsOf() {
    const g = this.state.grid;
    const p = g && g.periods || [];
    if (p.length) return p;
    return MONTHS.map((m, i) => `${this.state.year}-${String(i + 1).padStart(2, "0")}`);
  }
  key(id, period) {
    return `${id}|${period}`;
  }
  valueOf(row, period) {
    const k = this.key(row.storeId, period);
    if (k in this.state.dirty) return this.state.dirty[k];
    const c = (row.cells || {})[period];
    return c && Number(c.revenueGoal) ? String(Math.round(Number(c.revenueGoal))) : "";
  }
  isSuggested(row, period) {
    const k = this.key(row.storeId, period);
    if (k in this.state.dirty) return !!this.state.sugg[k];
    const c = (row.cells || {})[period];
    return !!(c && c.suggested);
  }
  rowMonths(row) {
    return this.periodsOf().map(p => Number(this.valueOf(row, p)) || 0);
  }
  rowTotal(row) {
    return this.rowMonths(row).reduce((a, v) => a + v, 0);
  }
  rowSuggested(row) {
    return this.periodsOf().some(p => this.isSuggested(row, p));
  }
  prevOf(row) {
    return (row.prevMonths || []).map(v => Number(v) || 0);
  }
  lastYearOf(row) {
    return row.lastYear != null ? Number(row.lastYear) || 0 : null;
  }
  // Spread weights: last year's months; else the row's current months; else an even split.
  weightsOf(row) {
    const prev = this.prevOf(row);
    if (prev.some(v => v > 0)) return prev;
    const cur = this.rowMonths(row);
    return cur.some(v => v > 0) ? cur : new Array(cur.length || 12).fill(1);
  }
  editMonth(row, period, v) {
    const clean = String(v).replace(/[^0-9.]/g, "");
    const k = this.key(row.storeId, period);
    this.setState(s => {
      const sugg = {
        ...s.sugg
      };
      delete sugg[k];
      return {
        dirty: {
          ...s.dirty,
          [k]: clean
        },
        sugg
      };
    });
  }
  editYear(row, text) {
    const id = row.storeId;
    const periods = this.periodsOf();
    const amt = parseAmount(text);
    this.setState(s => {
      const dirty = {
        ...s.dirty
      };
      const sugg = {
        ...s.sugg
      };
      if (amt != null) {
        const w = this._weights && this._weights[id] || this.weightsOf(row);
        const parts = spread(amt, w.slice(0, periods.length));
        periods.forEach((p, i) => {
          const k = this.key(id, p);
          dirty[k] = String(parts[i]);
          delete sugg[k];
        });
      } else if (!String(text).trim()) {
        periods.forEach(p => {
          const k = this.key(id, p);
          dirty[k] = "";
          delete sugg[k];
        });
      }
      return {
        dirty,
        sugg,
        drafts: {
          ...s.drafts,
          [id]: text
        }
      };
    });
  }
  focusYear(row) {
    this._weights = {
      ...(this._weights || {}),
      [row.storeId]: this.weightsOf(row)
    };
    const t = this.rowTotal(row);
    this.setState(s => ({
      drafts: {
        ...s.drafts,
        [row.storeId]: t ? String(Math.round(t)) : ""
      }
    }));
  }
  blurYear(row) {
    if (this._weights) delete this._weights[row.storeId];
    this.setState(s => {
      const d = {
        ...s.drafts
      };
      delete d[row.storeId];
      return {
        drafts: d
      };
    });
  }
  pendingTargets() {
    const {
      dirty
    } = this.state;
    return Object.entries(dirty).filter(([, v]) => String(v).trim() !== "" && Number.isFinite(Number(v))).map(([k, v]) => {
      const i = k.lastIndexOf("|");
      return {
        storeId: k.slice(0, i),
        period: k.slice(i + 1),
        revenueGoal: Number(v)
      };
    });
  }
  toggleOpen(id) {
    this.setState(s => {
      const open = {
        ...s.open
      };
      if (open[id]) delete open[id];else open[id] = true;
      return {
        open
      };
    });
  }

  // ---- render ----
  header() {
    const {
      year,
      busy
    } = this.state;
    const thisYear = new Date().getFullYear();
    const years = [thisYear - 1, thisYear, thisYear + 1];
    if (!years.includes(year)) years.push(year);
    const pending = this.state.grid ? this.pendingTargets().length : 0;
    const menu = [{
      key: "csv",
      label: "Import CSV",
      onClick: () => this.setState({
        csvOpen: true
      })
    }, {
      key: "tpl",
      label: "Download template",
      onClick: this.downloadTemplate
    }];
    return /*#__PURE__*/React.createElement(RepSubTop, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "/Stores"
      }, "Stores"), " \xB7 Goals"),
      title: `Store goals for ${year}`,
      meta: "Set a yearly goal for each store. We spread it across the months the way last year's sales fell.",
      backLabel: "Back to stores",
      onBack: () => this.props.history.push("/Stores")
    }, /*#__PURE__*/React.createElement("span", {
      className: "stg-year"
    }, /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "110px",
      value: year,
      onChange: this.setYear,
      options: years.sort().map(y => [y, String(y)])
    })), /*#__PURE__*/React.createElement(Menu, {
      label: "More",
      items: menu,
      triggerCls: "stg-more"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "stg-btn primary",
      disabled: busy || !pending,
      onClick: this.save
    }, "Save goals"));
  }
  renderPanels(rows) {
    const {
      year,
      csvOpen,
      csvText,
      note
    } = this.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, note ? /*#__PURE__*/React.createElement("div", {
      className: "stg-note"
    }, note, /*#__PURE__*/React.createElement("a", {
      className: "stg-x",
      href: "#",
      "aria-label": "Dismiss",
      onClick: e => {
        e.preventDefault();
        this.setState({
          note: null
        });
      }
    }, "\xD7")) : null, csvOpen && /*#__PURE__*/React.createElement("section", {
      className: "stg-panel"
    }, /*#__PURE__*/React.createElement("b", null, "Import goals from a spreadsheet"), /*#__PURE__*/React.createElement("label", {
      className: "stg-btn stg-file"
    }, "Choose CSV file", /*#__PURE__*/React.createElement("input", {
      type: "file",
      accept: ".csv,text/csv",
      onChange: this.onFile
    })), /*#__PURE__*/React.createElement("span", {
      className: "stg-muted"
    }, "Columns: store id, month (YYYY-MM), goal. Download the template from the \xB7\xB7\xB7 menu to start from your current goals, or paste rows below."), /*#__PURE__*/React.createElement("textarea", {
      className: "stg-csv",
      rows: 5,
      placeholder: `storeId,period,revenue_goal\n${rows[0] ? rows[0].storeId : "Naples"},${year}-01,25000`,
      value: csvText,
      onChange: e => this.setState({
        csvText: e.target.value
      })
    }), /*#__PURE__*/React.createElement("span", {
      className: "stg-row"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "stg-btn",
      disabled: !csvText.trim(),
      onClick: this.applyCsv
    }, "Fill in from these rows"), /*#__PURE__*/React.createElement("a", {
      className: "stg-textlink",
      href: "#",
      onClick: e => {
        e.preventDefault();
        this.setState({
          csvOpen: false,
          csvText: ""
        });
      }
    }, "Cancel"))));
  }
  render() {
    if (!hasTenantFeature("storePerformance")) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "Store Performance is not configured for this workspace."));
    }
    if (!isAdminUser()) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "Store goals are set by workspace owners and administrators."));
    }
    const {
      grid,
      error,
      year,
      growth,
      busy,
      q,
      showAll,
      open,
      drafts
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    const wrap = "territory-view ec-view ecc-view trr-view stores-view sales-view tr-view wa-view stg-view st-goals";
    if (grid === undefined) return /*#__PURE__*/React.createElement("div", {
      className: wrap
    }, this.header(), /*#__PURE__*/React.createElement("div", {
      className: "trr-body"
    }, /*#__PURE__*/React.createElement(Loader, null)));
    if (grid === null) {
      return /*#__PURE__*/React.createElement("div", {
        className: wrap
      }, this.header(), /*#__PURE__*/React.createElement("div", {
        className: "trr-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "wa-grid"
      }, /*#__PURE__*/React.createElement(Card, {
        title: "Goals"
      }, /*#__PURE__*/React.createElement(Empty, null, "Store goals couldn't be loaded right now. ", /*#__PURE__*/React.createElement("a", {
        className: "tr-link",
        href: "#",
        onClick: e => {
          e.preventDefault();
          this.load();
        }
      }, "Try again"), ". If it keeps happening, contact support.")))));
    }
    const thisYear = new Date().getFullYear();
    const prev = year - 1;
    const periods = this.periodsOf();
    const rows = (grid.rows || []).map(r => ({
      ...r,
      display: storeName(r),
      ly: this.lastYearOf(r)
    })).sort((a, b) => (Number(b.ly) || 0) - (Number(a.ly) || 0) || String(a.display).localeCompare(String(b.display)));
    const planTotal = rows.reduce((a, r) => a + this.rowTotal(r), 0);
    const prevTotal = rows.reduce((a, r) => a + (Number(r.ly) || 0), 0);
    const ql = q.trim().toLowerCase();
    const shown = ql ? rows.filter(r => `${r.display} ${r.storeId} ${typeLabel(r.type)}`.toLowerCase().includes(ql)) : rows;
    const visible = showAll || ql ? shown : shown.slice(0, CAP);
    const soldLabel = year < thisYear ? `Sold in ${year}` : "Sold so far";
    return /*#__PURE__*/React.createElement("div", {
      className: wrap
    }, this.header(), /*#__PURE__*/React.createElement("div", {
      className: "trr-body"
    }, this.renderPanels(rows), /*#__PURE__*/React.createElement("section", {
      className: "stg-start"
    }, /*#__PURE__*/React.createElement("b", {
      className: "stg-h"
    }, "Start from last year"), /*#__PURE__*/React.createElement("span", {
      className: "stg-copy"
    }, "Grow every store's ", prev, " sales by"), /*#__PURE__*/React.createElement("span", {
      className: "stg-pct"
    }, /*#__PURE__*/React.createElement("input", {
      type: "number",
      value: growth,
      min: -50,
      max: 200,
      step: 1,
      "aria-label": "Growth percent",
      onChange: e => this.setState({
        growth: e.target.value
      })
    }), /*#__PURE__*/React.createElement("span", null, "%")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "stg-btn",
      disabled: busy,
      onClick: this.fill
    }, "Fill in goals"), /*#__PURE__*/React.createElement("span", {
      className: "stg-fill"
    }), /*#__PURE__*/React.createElement("span", {
      className: "stg-total"
    }, /*#__PURE__*/React.createElement("span", {
      className: "stg-muted"
    }, "Goal total"), /*#__PURE__*/React.createElement("b", null, planTotal > 0 ? goalMoney(planTotal) : "$0"), prevTotal > 0 ? /*#__PURE__*/React.createElement("span", {
      className: "stg-muted stg-small"
    }, "vs ", goalMoney(prevTotal), " sold in ", prev) : null)), /*#__PURE__*/React.createElement("section", {
      className: "stg-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "stg-card-h"
    }, /*#__PURE__*/React.createElement("b", {
      className: "stg-h"
    }, "Goals by store"), /*#__PURE__*/React.createElement("span", {
      className: "stg-muted stg-small"
    }, "type a yearly number, or open a store to adjust single months"), /*#__PURE__*/React.createElement("span", {
      className: "stg-fill"
    }), /*#__PURE__*/React.createElement("input", {
      className: "stg-search",
      type: "search",
      value: q,
      placeholder: "Search stores",
      onChange: e => this.setState({
        q: e.target.value
      })
    })), rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "stg-scroll"
    }, /*#__PURE__*/React.createElement("table", {
      className: "stg-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Store"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Sold in ", prev), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, year, " goal"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, soldLabel), /*#__PURE__*/React.createElement("th", null, "Monthly spread"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, visible.map(r => {
      const id = r.storeId;
      const total = this.rowTotal(r);
      const months = this.rowMonths(r);
      const prevM = this.prevOf(r);
      const sug = this.rowSuggested(r);
      const isOpen = !!open[id];
      const draft = id in drafts ? drafts[id] : null;
      const cur = year > thisYear ? null : r.soldSoFar != null ? Number(r.soldSoFar) : null;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: id
      }, /*#__PURE__*/React.createElement("tr", {
        className: isOpen ? "open" : ""
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        className: "st-name-row"
      }, /*#__PURE__*/React.createElement("span", {
        className: "stg-name"
      }, r.display), /*#__PURE__*/React.createElement("span", {
        className: "st-type"
      }, typeLabel(r.type)))), /*#__PURE__*/React.createElement("td", {
        className: "n stg-muted"
      }, r.ly ? money(r.ly) : r.ly === 0 ? "none" : "-"), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, /*#__PURE__*/React.createElement("input", {
        className: `stg-goal${sug ? " sug" : ""}`,
        inputMode: "decimal",
        "aria-label": `${year} goal for ${r.display}`,
        value: draft != null ? draft : total ? goalMoney(total) : "",
        placeholder: "$0",
        onFocus: () => this.focusYear(r),
        onBlur: () => this.blurYear(r),
        onChange: e => this.editYear(r, e.target.value)
      })), /*#__PURE__*/React.createElement("td", {
        className: "n stg-muted"
      }, cur == null ? "-" : money(cur)), /*#__PURE__*/React.createElement("td", null, total ? /*#__PURE__*/React.createElement(Bars, {
        values: months
      }) : /*#__PURE__*/React.createElement(Bars, {
        values: prevM,
        muted: true
      })), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, /*#__PURE__*/React.createElement("a", {
        className: "stg-link",
        href: "#",
        "aria-expanded": isOpen,
        onClick: e => {
          e.preventDefault();
          this.toggleOpen(id);
        }
      }, isOpen ? "Close" : "By month"))), isOpen ? /*#__PURE__*/React.createElement("tr", {
        className: "stg-months-row"
      }, /*#__PURE__*/React.createElement("td", {
        colSpan: 6
      }, /*#__PURE__*/React.createElement("div", {
        className: "stg-months"
      }, periods.map((p, i) => {
        const k = this.key(id, p);
        return /*#__PURE__*/React.createElement("label", {
          key: p,
          className: "stg-month"
        }, /*#__PURE__*/React.createElement("span", {
          className: "m"
        }, MONTHS[Number(p.slice(5)) - 1] || p), /*#__PURE__*/React.createElement("input", {
          className: `stg-cell${this.isSuggested(r, p) ? " sug" : k in this.state.dirty ? " edited" : ""}`,
          inputMode: "decimal",
          value: this.valueOf(r, p),
          onChange: e => this.editMonth(r, p, e.target.value)
        }), /*#__PURE__*/React.createElement("span", {
          className: "ly"
        }, prevM[i] ? `${money(prevM[i])} in ${prev}` : `none in ${prev}`));
      })), /*#__PURE__*/React.createElement("p", {
        className: "stg-muted stg-small stg-month-note"
      }, "Changing a month changes the ", year, " goal. Typing a new yearly goal spreads it again across the months."))) : null);
    }), !visible.length ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: 6,
      className: "stg-muted"
    }, "No stores match \"", q, "\".")) : null))) : /*#__PURE__*/React.createElement("p", {
      className: "stg-muted stg-pad"
    }, "No stores yet. Stores appear once your sales data carries a store on each sale."), /*#__PURE__*/React.createElement(ShowAll, {
      total: ql ? 0 : shown.length,
      shown: CAP,
      open: showAll && !ql,
      onToggle: () => this.setState({
        showAll: !showAll
      }),
      allLabel: `Show all ${shown.length} stores`,
      note: "Yellow = a suggested goal you haven't saved yet."
    }))));
  }
}
export default withRouter(StoreTargetsView);